define(function(require) {

  const rowView = require('./v_itv_inspection_result_item');
  return Marionette.CollectionView.extend({
    config:{},
    tagName: 'div',
    childView: rowView,
    className: 'list-container',
    initialize:function(options){
      this.config = options.config;
      this.modalRegion = options.modalRegion;
      this.needsActionGrid = options.needsActionGrid;
      this.instrumentModel = options.instrumentModel;
      this.usesProviderView = options.usesProviderView;
    },
    childViewOptions:function(model, index){
      return {
        config:this.config,
        needsActionGrid:this.needsActionGrid,
        modalRegion: this.modalRegion,
        instrumentModel: this.instrumentModel,
        usesProviderView: this.usesProviderView
      }
    }
  });
});
